module.exports = __webpack_public_path__ + "static/media/widget1.add6a39f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/adminPanel/Content Management/assets/widget1.png
// module id = 1415
// module chunks = 1